// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import Link, { LinkPresentationProps, LinkProps } from "@insite/mobius/Link";
import * as React from "react";
import { css } from "styled-components";
import { fontConfig } from "@stoneage/XDL/constants";

type Props = LinkProps & {
    address1: string;
    address2?: string;
    city: string;
    state: string;
    postalCode: string;
};

export const googleMapsDirectionLinkStyles: LinkPresentationProps = {
    typographyProps: {
        ...fontConfig.smallSingleLine,
    },
    css: css`
        align-self: baseline;
    `,
};

const styles = googleMapsDirectionLinkStyles;
const GoogleMapsDirectionLink: React.FC<Props> = ({
    address1,
    address2,
    city,
    state,
    postalCode,
    target = "_blank",
    ...otherProps
}) => {
    const linkAddress = `http://maps.google.com/maps?daddr=${address1} ${address2}, ${city}, ${state} ${postalCode}`;
    return (
        <Link href={linkAddress} target={target} {...styles} {...otherProps}>
            {translate("Directions")}
        </Link>
    );
};

export default GoogleMapsDirectionLink;
